import { useEffect, useState } from "react";
import { api, inr } from "../lib/api";
import { useCart } from "../context/CartContext";
import { PageShell, Loader } from "../components/SiteChrome";

const KMark = () => (
  <svg viewBox="0 0 64 64" aria-hidden="true"><rect x="8" y="20" width="48" height="26" rx="11" fill="currentColor" /></svg>
);

function ProductCard({ p }) {
  const { add, items, setDrawerOpen } = useCart();
  const [qty, setLocalQty] = useState(1);
  const [done, setDone] = useState(false);
  const out = p.stock <= 0;

  const onAdd = () => {
    add(p.product_id, qty);
    setDone(true);
    setTimeout(() => setDone(false), 1400);
    setTimeout(() => setDrawerOpen(true), 500);
  };

  return (
    <article className={"prod" + (items[p.product_id] ? " has" : "")} data-testid={`product-card-${p.product_id}`}>
      <div className={"pack " + p.flavour_class}>
        <span className="mk"><KMark /></span>
        <span className="nm">KAFFGUM</span>
        <span className="fl">{p.name}</span>
      </div>
      <h2>{p.name}</h2>
      <div className="note">{p.note}</div>
      <p className="desc">{p.desc}</p>
      <div className="meta">
        <span>{p.pieces} pieces{p.stock > 0 && p.stock <= 10 ? ` · only ${p.stock} left` : ""}</span>
        <span className="price" data-testid={`product-price-${p.product_id}`}>{inr(p.price)}</span>
      </div>
      <div className="qty">
        <button type="button" onClick={() => setLocalQty(Math.max(1, qty - 1))} aria-label="One fewer" data-testid={`qty-dec-${p.product_id}`}>&minus;</button>
        <output data-testid={`qty-value-${p.product_id}`}>{qty}</output>
        <button type="button" onClick={() => setLocalQty(Math.min(99, qty + 1))} aria-label="One more" data-testid={`qty-inc-${p.product_id}`}>+</button>
      </div>
      <button className={"add" + (done ? " done" : "")} onClick={onAdd} disabled={out} data-testid={`add-to-cart-${p.product_id}`}>
        {out ? "Out of stock" : done ? "Added \u2713" : "Add to cart"}
      </button>
    </article>
  );
}

export default function Shop() {
  const [products, setProducts] = useState(null);

  useEffect(() => {
    api.get("/products").then(({ data }) => setProducts(data)).catch(() => setProducts([]));
  }, []);

  return (
    <PageShell kicker="Two flavours" title="Pick your tin." sub="Same pack, same 12 pieces. The only decision is which way you like it.">
      <div className="wrap">
        {!products ? <Loader /> : (
          <div className="shop-grid" data-testid="shop-grid">
            {products.map((p) => <ProductCard key={p.product_id} p={p} />)}
          </div>
        )}
      </div>
      <div className="shop-foot">
        <p className="legal">Not for under 18s, or anyone pregnant or sensitive to caffeine. One piece &asymp; one espresso.<br />
          This product is not intended to diagnose, treat, cure, or prevent any disease.</p>
      </div>
    </PageShell>
  );
}
